import { gql } from 'graphql-request';
import { requestWithAuth } from '@/utilities/graphQLClient';

import { PORTFOLIO_FRAGMENT } from './portfolio-fragment';
import type { PortfolioFragmentType } from './portfolio-fragment';

interface QueryResponse {
  errors?: Error[];
  Portfolio?: PortfolioFragmentType;
}

export const queryFn = async (id: string) => {
  const { Portfolio, errors } = await requestWithAuth<QueryResponse>(
    gql`
      query getPortfolio($id: String!) {
        Portfolio(id: $id) {
          ...portfolioFields
        }
      }
      ${PORTFOLIO_FRAGMENT}
    `,
    { id }
  );

  if (errors?.length) {
    const [firstError] = errors;
    throw new Error(firstError.message);
  }

  return Portfolio;
};
